import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function LinkWrapper({
  children,
  link,
  className,
  style,
}: {
  children: React.ReactNode;
  link?: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  if (!link && (className || style)) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  if (!link) {
    return <>{children}</>;
  }

  const isInternalLink = (): boolean => {
    const url = link;
    if (!url) return false;
    if (url.startsWith('/') || !url.startsWith('http')) return true;

    try {
      const parsed = new URL(url);
      if (typeof window !== 'undefined') {
        return parsed.origin === window.location.origin;
      }
      return parsed.hostname.endsWith('storyblocks.com');
    } catch {
      return true;
    }
  };

  const internal = isInternalLink();
  const linkProps = {
    href: link,
    className: twMerge('no-underline hover:no-underline', className),
    target: internal ? undefined : '_blank',
    rel: internal ? undefined : 'noopener noreferrer',
    style,
  };

  return <a {...linkProps}>{children}</a>;
}
